// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18TF_","name":"styles_name__YdG-s","phone":"styles_phone__3yZ0V"};